import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import {
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { finalize, first } from 'rxjs/operators';
import { TwoFactorAuthenticationService } from '../../service/two-factor-authentication.service';
import { InputOtpModule } from 'primeng/inputotp';
import { NotificationService } from '@shared/services/notifications/notification.service';
import { AppFormFieldErrorDirective } from '@shared/directives/app-form-field-error.directive';
import { getFirebaseErrorMessage } from '@core/services/auth-firebase/firebase-error-map';

@Component({
  selector: 'app-deactivate-2fa',
  standalone: true,
  imports: [
    ButtonModule,
    ReactiveFormsModule,
    InputOtpModule,
    AppFormFieldErrorDirective,
  ],
  templateUrl: './deactivate.component.html',
  styleUrls: ['./deactivate.component.scss'],
})
export class DeactivateComponent {
  submitting: boolean = false;
  form: FormGroup;

  constructor(
    public ref: DynamicDialogRef,
    private twoFactorService: TwoFactorAuthenticationService,
    private fb: FormBuilder,
    private notificationService: NotificationService
  ) {
    this.form = this.fb.group({
      code: [
        '',
        [Validators.required, Validators.minLength(6), Validators.maxLength(6)],
      ],
    });
  }

  onCancel(): void {
    this.ref.close(false);
  }

  onConfirm(): void {
    if (this.submitting) return;
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.submitting = true;
    this.twoFactorService
      .disableTwoFactorAuth(this.form.value.code)
      .pipe(
        first(),
        finalize(() => (this.submitting = false))
      )
      .subscribe({
        next: () => {
          this.notificationService.show(
            'Success',
            'Autenticación de dos factores desactivada correctamente',
            'success'
          );
          this.ref.close(true);
        },
        error: (error) => {
          this.notificationService.show(
            'Error',
            'Error al desactivar la autenticación de dos factores' +
              getFirebaseErrorMessage(error.code),
            'error'
          );
        },
      });
  }
}
